/* eslint-disable */
import React, { Component } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import cookie from "react-cookies";
import { apiUrl, clientheaderconfig } from "../../Helpers/Config";
import { CompanyID } from "../../Helpers/SettingHelper";
class Topmenu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      clientDetails: "",
    };
    this.loadSetting();
  }
  loadSetting() {
    var urlShringTxt =
      apiUrl + "client/details/" + CompanyID();
    axios.get(urlShringTxt, clientheaderconfig).then((res) => {
      if (res.data.status === "ok") {
        this.setState({ clientDetails: res.data.result });
      }
    })
    .catch();
  }
  render() {
    const companyTwilioWhatsappAvailableMsg = this.state.clientDetails?.companyTwilioWhatsappAvailableMsg || 0;
    return (
      <nav
        className="layout-navbar container-xxl navbar navbar-expand-xl navbar-detached align-items-center bg-navbar-theme"
        id="layout-navbar"
      >
        <div className="layout-menu-toggle navbar-nav align-items-xl-center me-3 me-xl-0 d-xl-none">
          <a className="nav-item nav-link px-0 me-xl-4" href={void 0}>
            <i className="mdi mdi-menu mdi-24px"></i>
          </a>
        </div>

        <div
          className="navbar-nav-right d-flex align-items-center"
          id="navbar-collapse"
        >
          <ul className="navbar-nav flex-row align-items-center ms-auto">
            {parseInt(this.state.clientDetails?.companySMSBalance)>0? (
              <li className={`${parseInt(this.state.clientDetails?.companySMSBalance)<=25?'text-danger':''}`}>
                SMS Balance: {this.state.clientDetails?.companySMSBalance}
              </li>
            ):(parseInt(this.state.clientDetails?.companySMSBalance)==0?( <li className="text-danger">
                SMS Balance: {this.state.clientDetails?.companySMSBalance}
              </li>):'')}
              {this.state.clientDetails?.companyEnableWhatsappCampaign===true && (
                <li className={`${parseInt(companyTwilioWhatsappAvailableMsg)<=25?'text-danger':''}`}>
                Whats App Message Balance: {this.state.clientDetails?.companyTwilioWhatsappAvailableMsg}
              </li>
              )}
              <li>
                &nbsp; Welcome {cookie.load('clientFirstName') || ''}
              </li>
              
            <li className="nav-item navbar-dropdown dropdown-user dropdown">
              <a
                className="nav-link dropdown-toggle hide-arrow"
                href={void 0}
                data-bs-toggle="dropdown"
              >
                <div className="avatar avatar-online">
                  <img
                    src="/assets/img/avatars/1.png"
                    alt=""
                    className="w-px-40 h-auto rounded-circle"
                  />
                </div>
              </a>
              <ul className="dropdown-menu dropdown-menu-end">
                <li>
                  <a className="dropdown-item" href={void 0}>
                    <div className="d-flex">
                      <div className="flex-shrink-0 me-3">
                        <div className="avatar avatar-online">
                          <img
                            src="/assets/img/avatars/1.png"
                            alt=""
                            className="w-px-40 h-auto rounded-circle"
                          />
                        </div>
                      </div>
                      <div className="flex-grow-1">
                        <span className="fw-semibold d-block">
                          {cookie.load("clientFirstName")}
                        </span>
                      </div>
                    </div>
                  </a>
                </li>
                <li>
                  <div className="dropdown-divider"></div>
                </li>
                <li>
                  <Link className="dropdown-item" to={"/clientpanel/settings"}>
                    <i className="mdi mdi-cog-outline me-2"></i>
                    <span className="align-middle">Settings</span>
                  </Link>
                </li>
                {this.state.clientDetails?.companyEnableAdditionalCharge === true &&
                <li>
                  <Link className="dropdown-item" to={"/clientpanel/additional-charge"}>
                    <i className="mdi mdi-cog-outline me-2"></i>
                    <span className="align-middle">Additional Charge</span>
                  </Link>
                </li>
                }
                <li>
                  <div className="dropdown-divider"></div>
                </li>
                <li>
                  <Link className="dropdown-item" to={"/logout"}>
                    <i className="mdi mdi-logout me-2"></i>
                    <span className="align-middle">Log Out</span>
                  </Link>
                </li>
              </ul>
            </li>
          </ul>
        </div>

        <div className="navbar-search-wrapper search-input-wrapper d-none">
          <input
            type="text"
            className="form-control search-input container-xxl border-0"
            placeholder="Search..."
            aria-label="Search..."
          />
          <i className="mdi mdi-close search-toggler cursor-pointer"></i>
        </div>
      </nav>
    );
  }
}

export default Topmenu;
